module.exports = __webpack_public_path__ + "img/flower-left.f8cef623.svg";